import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import pretty from '@st-operations/uikit/lib/pretty.js'
import { IconButton, ICON_TYPES } from '@st-operations/uikit/src/v2/index'

import { formatValue } from '../utils.js'
import './styles.scss'

import { useEventFeedsContext } from '../../../../context/index.jsx'

const FilterMenuItem = ({
  attribute,
  className,
  id,
  isSelected,
  onClick,
  onDelete,
  operator,
  value,
}) => {
  const {
    schema: {
      // eslint-disable-next-line no-unused-vars
      filters: { type = null, default: defaultKey = null, ...filters },
    },
  } = useEventFeedsContext()

  return (
    <div
      className={classnames('filter-menu-item', className, {
        'filter-menu-item--selected': isSelected,
      })}
    >
      <button
        aria-label={`Start editing the ${attribute} attribute`}
        className="filter-menu-item__button"
        onClick={onClick}
        value={id}
      >
        <span
          className={classnames('filter-menu-item__label filter-menu-item__value--bold', {
            'filter-menu-item__value--green': isSelected,
          })}
        >
          {filters[attribute]?.label || '-'}
        </span>
        <span className="filter-menu-item__operator filter-menu-item__value filter-menu-item__value--bold">
          {pretty(operator) || '-'}
        </span>
        <span className="filter-menu-item__value">
          {pretty(operator) === 'Is Not Null' ? ' ' : formatValue(value, 28) || '-'}
        </span>
      </button>
      <IconButton
        ariaLabel={`Delete filter with ${attribute} attribute`}
        iconProps={{ icon: 'trashcan', type: ICON_TYPES.OUTLINE, width: '20px', height: '20px' }}
        onClick={() => onDelete(id)}
        classes={{
          icon: 'filter-menu-item__delete-icon',
          button: 'filter-menu-item__delete-button',
        }}
      />
    </div>
  )
}

FilterMenuItem.propTypes = {
  attribute: PropTypes.string,
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  id: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  operator: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.array, PropTypes.number]),
}

FilterMenuItem.defaultProps = {
  attribute: '',
  className: '',
  isSelected: false,
  onClick: () => {},
  onDelete: () => {},
  operator: '',
  value: '',
}

export default FilterMenuItem
